import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import formatPublisherAddress from 'shared-utils/src/leads/publisherAddress';

import Buttons from './Buttons';
import Agents from '../Agents';

import './critical.scss';

const Agency = ({
  device,
  data,
  user,
  isLocalStorageAvailable,
  isFromAgentPro,
  hasPlaceholder,
  logoSrc,
}) => {
  const {
    publisherName,
    description,
    hasCrossSubscription,
    publisherAddress: { street, town, province, state, postcode },
    publisherUrl,
    hasAgents,
    agentList: { list = [], total = 0 } = {},
  } = data;

  const descEl = useRef(null);
  const [revealButton, setRevealButton] = useState(false);
  const [descReveal, setDescReveal] = useState(false);

  const expandDesc = () => {
    setRevealButton(false);
    setDescReveal(true);
  };

  useEffect(() => {
    if (descEl.current) {
      if (descEl.current.clientHeight < descEl.current.scrollHeight) {
        setRevealButton(true);
      }
    }
  }, []);

  return (
    <div className="c-bg--w bb--s">
      <div className="pbInfos__ctn">
        <div className="pbInfos__grids">
          <div className="pbInfos__grids__g1">
            <div className="pbInfos__variablegrid pbInfos__logoname">
              {!hasPlaceholder && (
                <img
                  className={`pbInfos__logo${hasCrossSubscription
                    ? ' pbInfos__logo--pm'
                    : ' pbInfos__logo--csa'
                    }`}
                  src={logoSrc}
                  alt={publisherName}
                />
              )}
              <div className="pbInfos__nameandaddr">
                <h1 className="pbInfos__name c-txt--secondary">{publisherName}</h1>
                <div className="pbInfos__addr tp-s--m tp-w--s c-txt--f5">
                  {formatPublisherAddress({
                    street,
                    town,
                    province,
                    state,
                    postcode,
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="pbInfos__grids__g2">
            <div className="pbInfos__actions">
              <div className="pbInfos__actions__agnts">
                {hasAgents && !isFromAgentPro && (
                  <Agents
                    list={list}
                    total={total}
                    link={`${publisherUrl}agenti/`}
                    publisherName={publisherName}
                    className="pbInfos__agents"
                  />
                )}
              </div>
              <Buttons
                publisher={data}
                device={device}
                user={user}
                isLocalStorageAvailable={isLocalStorageAvailable}
                logoSrc={logoSrc}
              />
            </div>
          </div>
          {description && (
            <div className="pbInfos__grids__g3 is-rel">
              <p
                ref={descEl}
                className={`pbInfos__desc${descReveal ? ' pbInfos__desc--open' : ''} is-rel tp-s--l tp-w--s c-txt--f5`}
              >
                {description}
              </p>
              {revealButton && (
                <button
                  type="button"
                  onClick={expandDesc}
                  className="pbInfos__desc__expand tp-s--s c-txt--secondary"
                >
                  <span className="tp--u">espandi</span>
                </button>
              )}                
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Agency;

Agency.propTypes = {
  device: PropTypes.string,
  data: PropTypes.instanceOf(Object),
  user: PropTypes.instanceOf(Object),
  isLocalStorageAvailable: PropTypes.bool,
  isFromAgentPro: PropTypes.bool,
  hasPlaceholder: PropTypes.bool,
  logoSrc: PropTypes.string,
};

Agency.defaultProps = {
  device: '',
  data: {},
  user: {},
  isLocalStorageAvailable: false,
  isFromAgentPro: false,
  hasPlaceholder: false,
  logoSrc: '',
};
